// list all environment variables
const env = {
  SERVICE_ID: process.env.REACT_APP_SERVICE_ID,
  TEMPLATE_ID: process.env.REACT_APP_TEMPLATE_ID,
  PUBLIC_KEY: process.env.REACT_APP_PUBLIC_KEY,
};

export { env };
